/* ============================================================
   Car Door Landing - Interactive JS
   - Countdown timer (persists across sessions via localStorage)
   - Bundle selector
   - Color selector
   - Sticky ATC visibility
   - Add to cart (Shopify AJAX API)
   ============================================================ */

(function () {
  'use strict';

  // ---------- Countdown ----------
  function initCountdown() {
    var el = document.querySelector('[data-cdp-countdown]');
    if (!el) return;

    var hourEl = el.querySelector('[data-h]');
    var minEl = el.querySelector('[data-m]');
    var secEl = el.querySelector('[data-s]');

    // ⏱️ Duración del contador en HORAS. Cámbiala desde window.CDP_COUNTDOWN_HOURS
    //    o con el atributo data-hours en el HTML. Por defecto: 2 horas.
    var HOURS = parseFloat(
      el.getAttribute('data-hours') || window.CDP_COUNTDOWN_HOURS || 2
    );

    // Cada visitante tiene su propio contador que persiste al refrescar.
    // La clave incluye las horas: si cambias HOURS, el contador se reinicia.
    var key = 'cdp_countdown_end_' + HOURS;
    var endTs = parseInt(localStorage.getItem(key), 10);
    var now = Date.now();
    if (!endTs || endTs < now) {
      endTs = now + HOURS * 60 * 60 * 1000;
      localStorage.setItem(key, String(endTs));
    }

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var diff = Math.max(0, endTs - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (hourEl) hourEl.textContent = pad(h);
      if (minEl) minEl.textContent = pad(m);
      if (secEl) secEl.textContent = pad(s);
      if (diff <= 0) {
        // Reset for next visit
        localStorage.removeItem(key);
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  // ---------- Bundle + color selector ----------
  function initBundles() {
    var bundles = document.querySelectorAll('[data-cdp-bundle]');
    if (!bundles.length) return;

    function setActiveBundle(target) {
      bundles.forEach(function (b) { b.classList.remove('is-active'); });
      target.classList.add('is-active');
      updateMainCta();
    }

    bundles.forEach(function (bundle) {
      // Click en la tarjeta del combo lo activa
      bundle.addEventListener('click', function () {
        setActiveBundle(bundle);
      });
    });

    function updateMainCta() {
      var active = document.querySelector('[data-cdp-bundle].is-active');
      if (!active) return;
      // La variante y el precio ahora vienen del combo (ya no del color)
      var variantId = active.getAttribute('data-variant-id') || '';
      var priceKey = active.getAttribute('data-price-key')
        || active.getAttribute('data-bundle-id') || '';

      // Read live prices from global store (set by price editor)
      var prices = window.__cdpPrices || null;
      var price = '';
      var compare = '';
      var currency = '$';
      if (prices && priceKey && prices[priceKey]) {
        price = prices[priceKey].price;
        compare = prices[priceKey].compare;
        currency = prices.currency || '$';
      } else {
        // Fallback to legacy data attributes
        price = active.getAttribute('data-price') || '';
        compare = active.getAttribute('data-compare') || '';
      }

      // Escribir la variante en el formulario nativo (Releasit lo lee de aquí)
      var variantSelect = document.querySelector('[data-cdp-variant-select]');
      if (variantSelect && variantId) variantSelect.value = variantId;

      var btn = document.querySelector('[data-cdp-atc]');
      var stickyBtn = document.querySelector('[data-cdp-sticky-atc]');
      var stickyPrice = document.querySelector('[data-cdp-sticky-price]');
      var stickyCompare = document.querySelector('[data-cdp-sticky-compare]');

      [btn, stickyBtn].forEach(function (b) {
        if (b) b.setAttribute('data-variant-id', variantId);
      });
      var priceEl = document.querySelector('[data-cdp-atc-price]');
      if (priceEl && price) priceEl.textContent = currency + price;
      var heroPriceEl = document.querySelector('[data-cdp-atc-price-hero]');
      if (heroPriceEl && price) heroPriceEl.textContent = currency + price;
      var heroBuy = document.querySelector('[data-cdp-buy]');
      if (heroBuy) heroBuy.setAttribute('data-variant-id', variantId);
      if (stickyPrice && price) stickyPrice.textContent = currency + price;
      if (stickyCompare && compare) stickyCompare.textContent = currency + compare;
    }

    // Expose so the price editor can trigger a refresh after saving
    window.__cdpRefreshCta = updateMainCta;

    updateMainCta();
  }

  // ---------- Sticky ATC visibility ----------
  function initStickyAtc() {
    var sticky = document.querySelector('[data-cdp-sticky]');
    if (!sticky) return;
    var heroBottom = document.querySelector('.cdp-hero');
    var shopSection = document.querySelector('.cdp-shop');

    function check() {
      if (!heroBottom) return;
      var heroRect = heroBottom.getBoundingClientRect();
      var shopRect = shopSection ? shopSection.getBoundingClientRect() : null;
      var pastHero = heroRect.bottom < 0;
      var inShop = shopRect && shopRect.top < window.innerHeight && shopRect.bottom > 0;
      // Show sticky after hero, hide while user is in the shop section
      if (pastHero && !inShop) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  // ---------- Add to cart (Shopify AJAX) / link externo (RealeSet) ----------
  function initAtc() {
    function handler(e) {
      var btn = e.target.closest('[data-cdp-atc], [data-cdp-sticky-atc], [data-cdp-buy]');
      if (!btn) return;

      // 1) Si el botón apunta al hook de Releasit, dejar pasar el clic
      //    (Releasit intercepta el enlace y abre su formulario COD)
      var customLink = (btn.getAttribute('data-cdp-link') || '').trim();
      if (!customLink && window.CDP_BUY_LINK) customLink = String(window.CDP_BUY_LINK).trim();
      if (customLink.indexOf('rsi-btn-hook') !== -1) {
        // No hacer nada: el <a href="/rsi-btn-hook"> + Releasit hacen el trabajo
        if (btn.tagName !== 'A') window.location.href = customLink;
        return;
      }
      // 1b) Cualquier otro enlace externo: navegar directo
      if (customLink) {
        e.preventDefault();
        window.location.href = customLink;
        return;
      }

      // 2) Si no hay enlace, flujo de carrito Shopify
      if (btn.tagName === 'A') e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';

      // Try Shopify cart API; fall back to direct checkout link
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart add failed');
          return r.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          // Fallback for non-Shopify preview
          window.location.href = '/cart/' + variantId + ':1';
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    }
    document.addEventListener('click', handler);
  }

  // ---------- Boot ----------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // ---------- Reducción de ruido (texto configurable / se puede ocultar) ----------
  function initNoiseClaim() {
    var pct = window.CDP_NOISE_PERCENT;
    var els = document.querySelectorAll('[data-cdp-noise]');
    if (pct === false || pct === 0 || pct === '0' || pct === '') {
      els.forEach(function (el) { el.style.display = 'none'; });
      return;
    }
    var value = (pct === undefined || pct === null) ? '85%' : String(pct);
    if (value.indexOf('%') === -1) value += '%';
    document.querySelectorAll('[data-cdp-noise-pct]').forEach(function (el) {
      el.textContent = value;
    });
  }

  // ---------- Nombre de la tienda en el header (opcional, sobreescribe el automático) ----------
  function initShopName() {
    var name = window.CDP_SHOP_NAME;
    if (!name) return;
    document.querySelectorAll('[data-cdp-shopname]').forEach(function (el) {
      el.textContent = name;
    });
  }

  function boot() {
    initCountdown();
    initBundles();
    initStickyAtc();
    initAtc();
    initNoiseClaim();
    initShopName();
  }
})();
